import "./App.css";
import Footer from "./components/Footer/Footer";
import Articles from "./pages/Articles/Articles";
import Awards from "./pages/Awards/Awards";
import Content from "./pages/content/Content";
import Home from "./pages/Home/Home";
import Intro from "./pages/Intro/Intro";
import Story from "./pages/Story/Story";

function App() {
  return (
    <main>
      <Home />
      <Story />
      <Content />
      <Articles />
      <Awards />
      <Footer />
    </main>
  );
}

export default App;
